import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { Link as LinkInterface } from '../../interfaces/link';

interface SideNavigation {
  title: string;
  size: string;
  categories: LinkInterface[];
}

function SideNavigation({ title, size, categories }: SideNavigation) {
  const [activeLink, setActiveLink] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const extractedCategories = categories.filter((c) => c.__typename !== 'ContentfulRichText');

  useEffect(() => {
    const htmlElement = document.querySelector('html');
    htmlElement.classList.add('cl-smooth-scroll');
    return () => {
      htmlElement.classList.remove('cl-smooth-scroll');
    };
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const urlHash = window.location.hash.replace('#', '');

      if (urlHash) {
        const targetElement = document.getElementById(urlHash);
        setActiveLink(urlHash);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  }, [typeof window !== 'undefined' ? window.location.hash : null]);

  const renderSideNavigation = (category: LinkInterface, index: number) => {
    return (
      <Link
        key={index}
        to={(category.linkedPage?.slug || category.externalUrl) ?? ''}
        activeClassName='cl-side-nav__menu-item-link--active'
        className={`cl-side-nav__menu-item-link ${
          activeLink === category.externalUrl?.replace('#', '')
            ? 'cl-side-nav__menu-item-link--active'
            : ''
        }`}
        onClick={() => setActiveLink(category.externalUrl?.replace('#', ''))}
        data-to-scrollspy-id={category.link_id}
      >
        {category.linkName}
      </Link>
    );
  };

  return (
    <>
      <nav className={`cl-side-nav ${size ? `cl-side-nav--${size}` : ''}`}>
        <div className='cl-side-nav__dropdown' id='dropdown'>
          {/*  <!--  Start Dropdown trigger --> */}
          <div
            className='cl-button cl-button--lg cl-button--primary cl-button--normal cl-button--elevated'
            onClick={() => setIsOpen(!isOpen)}
            aria-expanded={isOpen ? 'true' : 'false'}
          >
            <span>{title}</span>

            <span className='relative only:-mx-5'>
              <svg
                className='w-4 h-4'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                stroke='currentColor'
                strokeWidth='1.5'
                aria-labelledby='t-01 d-01'
                role='graphics-symbol'
              >
                <title id='t-01'>Dropdown Icon</title>
                <desc id='d-01'>Dropdown Icon</desc>
                <path
                  d='M12 6L8.18844 9.8112C8.16371 9.83597 8.13434 9.85562 8.102 9.86903C8.06967 9.88243 8.035 9.88933 8 9.88933C7.965 9.88933 7.93033 9.88243 7.898 9.86903C7.86566 9.85562 7.83629 9.83597 7.81156 9.8112L4 6'
                  stroke='currentColor'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </span>
          </div>
          <ul className={`${isOpen ? 'flex' : 'hidden'} cl-side-nav__dropdown-list`}>
            {extractedCategories.map((item, index) => (
              <li key={index}>
                <a
                  className={`cl-side-nav__dropdown-link ${activeLink === index ? 'active' : ''}`}
                  href={(item.linkedPage?.slug || item.externalUrl) ?? ''}
                  onClick={() => setIsOpen(false)}
                >
                  <span className='flex flex-col gap-1 overflow-hidden whitespace-nowrap'>
                    <span className='leading-5 truncate'>{item.linkName}</span>
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
        {title && <h3 className='cl-side-nav__title'>{title}</h3>}

        <ul className='cl-side-nav__menu'>
          {categories.map((category, index) => (
            <li key={index} className='cl-side-nav__menu-item'>
              {renderSideNavigation(category, index)}
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}

export default SideNavigation;
